import { ref } from 'vue'

const events = ref({})

export { events }